<template>
<div id="pageDashboard" v-if="!Issuperadmin">
    <v-container grid-list-xl fluid>
        <v-layout wrap>
            <v-flex xs12>
                <v-tabs slider-color="orange">
                    <v-flex xs12>
                        <template v-if="showLoadSearchTab">
                            <v-tab><strong> Load Search </strong></v-tab>
                        </template>
                        <template v-if="showTruckSearchTab">
                            <v-tab v-if="showTruckSearchTab"><strong> Truck Search</strong> </v-tab>
                        </template>
                    </v-flex>
                    <template v-if="showLoadSearchTab">
                        <v-tab-item>
                            <v-card>
                                <v-card-text class="pa-0">
                                    <LoadSearchFormDb :dashboard_equipment_types="equipment_types" :dashboard_equipment_type_id_list="equipment_type_id_list"></LoadSearchFormDb>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </template>
                    <template v-if="showTruckSearchTab">
                        <v-tab-item>
                            <v-card>
                                <v-card-text class="pa-0">
                                    <TruckSearchFormDb :dashboard_equipment_types="equipment_types" :dashboard_equipment_type_id_list="equipment_type_id_list"></TruckSearchFormDb>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </template>
                </v-tabs>
            </v-flex>
            <v-flex lg12>
                <v-toolbar card color="white" v-if="userStore.user.isImr">
                    <v-toolbar-title>
                        <h3>Coming Soon</h3>
                    </v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-flex lg4 md4 xs12 v-if="!userStore.user.isImr"> <a href="http://www.loadmax.com/news" target="_blank" class="dashboard-tiles-link"> <img src="/static/dashboard/maxnews.png" alt="Max News" class="dashboard-tiles"> </a> </v-flex>
            <v-flex lg4 md4 xs12 v-if="!userStore.user.isImr"> <a href="https://forum.loadmax.com" target="_blank" class="dashboard-tiles-link"> <img src="/static/dashboard/maxtalks.png" alt="Max News" class="dashboard-tiles"> </a> </v-flex>
            <v-flex lg4 md4 xs12 v-if="!userStore.user.isImr"> <img src="/static/dashboard/comingsoon.png" alt="Max News" class="dashboard-tiles"> </v-flex>
        </v-layout>
    </v-container>
    <GoogleAds></GoogleAds>
</div>
<div id="pageDashboard" v-else>
    <template>
        <v-toolbar class="dashboard-toolbar-admin" color="orange" dark>
            <v-toolbar-title>DASHBOARD</v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="text-custom-font">{{ new Date()  | moment("utc","dddd, MMMM Do") }}</span>
            <!-- &nbsp;&nbsp;
        <v-icon>fa-file-pdf</v-icon>
        &nbsp;&nbsp;
        <v-icon>fa-print</v-icon> -->
        </v-toolbar>
    </template>
    <v-container grid-list-xl fluid>
        <v-layout wrap>
            <v-flex xs12 pt-0 pl-0 pr-0>
                <v-card class="dashbrd-border" pa-0>
                    <v-card-text pa-0>
                        <v-flex xs12 pa-0>
                            <h1 class="titleH1">
                                <v-icon>fa-user-circle</v-icon>
                                Users
                            </h1>
                        </v-flex>

                        <v-layout wrap>

                            <v-flex xs12 pa-0 class="text-md-center">
                                <div class=" blockDiv">
                                    <ul>
                                        <li>
                                            <h1>{{(dashAnalyticsData && dashAnalyticsData.statusWiseUsersCount && dashAnalyticsData.statusWiseUsersCount.all && dashAnalyticsData.statusWiseUsersCount.all > 0)?dashAnalyticsData.statusWiseUsersCount.all : dashboardDefaultValue }}</h1>
                                            <span>ALL</span>
                                        </li>
                                        <li v-for="(userStatus,index) in dashAnalyticsData.userStatusData" :key="index">
                                            <h1>{{userStatus.value}}</h1>
                                            <span>{{userStatus.label}}</span>
                                            <template v-if="userStatus.label == 'Active'">
                                              <div class="truckers">
                                                  <span>Truckers</span>
                                                  <!--<h6><span style="font-size: 14px !important;" class="coming">coming soon</span></h6>-->
                                                  <h1>{{dashAnalyticsData.trucker_count}}</h1>

                                              </div>
                                              <div class="brokers">
                                                  <span>Brokers</span>
                                                  <!--<h6><span style="font-size: 14px !important;" class="coming">coming soon</span></h6>-->
                                                  <h1>{{dashAnalyticsData.broker_count}}</h1>
                                              </div>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md4 pl-0>
                <v-card class="dashbrd-border">
                    <v-card-text pa-0>
                        <v-flex xs12 pa-0>
                            <h1 class="titleH1">
                                <v-icon>fa-cube</v-icon>
                                Loads
                            </h1>
                        </v-flex>
                        <v-layout wrap>
                            <v-flex xs12 pa-0 class="text-md-center">

                                <ul class="multi">
                                    <li>
                                        <h1>{{(dashAnalyticsData && dashAnalyticsData.allLoads && dashAnalyticsData.allLoads > 0)?dashAnalyticsData.allLoads : dashboardDefaultValue }}</h1>
                                        <span>ALL</span>
                                    </li>
                                    <li>
                                        <h1>{{(dashAnalyticsData && dashAnalyticsData.loadsToday && dashAnalyticsData.loadsToday > 0)?dashAnalyticsData.loadsToday : dashboardDefaultValue }}</h1>
                                        <span>TODAY'S LOAD</span>
                                    </li>
                                    <li>
                                        <h1>{{loadsAvg}}</h1>
                                        <span>AVG DAILY</span>
                                    </li>
                                    <li>
                                        <h1>{{(dashAnalyticsData && dashAnalyticsData.loadsToday && dashAnalyticsData.loadsToday > 0)? (dashAnalyticsData.loadsToday + loadHistoricalData) : (dashboardDefaultValue + loadHistoricalData) }}</h1>
                                        <span>HISTORICAL</span>
                                    </li>
                                </ul>

                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md4>
                <v-card class="dashbrd-border">
                    <v-card-text pa-0>
                        <v-flex xs12 pa-0>
                            <h1 class="titleH1">
                                <v-icon>fa-cube</v-icon>
                                Post Once Loads
                            </h1>
                        </v-flex>
                        <v-layout wrap>
                            <v-flex xs12 pa-0 class="text-md-center">

                                <ul class="multi">
                                    <li>
                                        <h1>{{(dashAnalyticsData && dashAnalyticsData.totalPostonceLoads && dashAnalyticsData.totalPostonceLoads > 0)?dashAnalyticsData.totalPostonceLoads : dashboardDefaultValue }}</h1>
                                        <span>ALL</span>
                                    </li>
                                    <li>
                                        <h1>{{(dashAnalyticsData && dashAnalyticsData.todayPostonceLoads && dashAnalyticsData.todayPostonceLoads > 0)?dashAnalyticsData.todayPostonceLoads : dashboardDefaultValue }}</h1>
                                        <span>TODAY'S LOAD</span>
                                    </li>
                                    <li>
                                        <!--<h1><span class="coming">coming soon</span></h1>-->
                                        <h1>{{postonceloadsAvg}}</h1>
                                        <span>AVG DAILY</span>
                                    </li>
                                    <li>
                                        <h1>{{(dashAnalyticsData && dashAnalyticsData.todayPostonceLoads && dashAnalyticsData.todayPostonceLoads > 0)? (dashAnalyticsData.todayPostonceLoads + dashAnalyticsData.historicalPostonceLoads) : (dashboardDefaultValue + dashAnalyticsData.historicalPostonceLoads) }}</h1>
                                        <span>HISTORICAL</span>
                                    </li>
                                </ul>

                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md4 pr-0>
                <v-card class="dashbrd-border">
                    <v-card-text pa-0>
                        <v-flex xs12 pa-0>
                            <h1 class="titleH1">
                                <v-icon>local_shipping</v-icon>
                                Trucks
                            </h1>
                        </v-flex>
                        <v-layout wrap>
                            <v-flex xs12 pa-0 class="text-md-center">

                                <ul class="multi">
                                    <li>
                                        <h1>{{(dashAnalyticsData && dashAnalyticsData.trucksToday && dashAnalyticsData.trucksToday > 0)?dashAnalyticsData.trucksToday : dashboardDefaultValue }}</h1>
                                        <span>ALL</span>
                                    </li>
                                    <li>
                                        <!-- <h1>67</h1> -->
                                        <h1> <span class="coming">coming soon</span></h1>
                                        <span>AVG DAILY</span>
                                    </li>
                                    <li>
                                        <!-- <h1>1200</h1> -->
                                        <h1><span class="coming">coming soon</span></h1>
                                        <span>HISTORICAL</span>
                                    </li>
                                    <li>
                                        <!-- <h1>1200</h1> -->
                                        <h1><span class="coming">coming soon</span></h1>
                                        <span>HISTORICAL</span>
                                    </li>
                                </ul>

                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md8 pl-0>
                <v-card class="dashbrd-border">
                    <v-card-text pa-0>
                        <v-flex xs12 pa-0>
                            <h1 class="titleH1">
                                <v-icon>fa-cube</v-icon>
                                <router-link :to="{ name: 'MpCodesList'}">
                                    MP CODES
                                </router-link>
                            </h1>
                        </v-flex>
                        <v-layout wrap>
                            <v-flex xs12 pa-0 class="text-md-center">
                                <div class=" blockDiv mpcodeblock">
                                    <ul>
                                        <li>
                                            <h1>{{mpCodesAll}}</h1>
                                            <span>ALL</span>
                                        </li>
                                        <li>
                                            <h1>{{mpCodesClick}}</h1>
                                            <!--<span class="coming">coming soon</span>-->
                                            <span>CLICKED</span>
                                        </li>
                                        <li>
                                            <h1>{{mpCodesCompleted}}</h1>
                                            <span>COMPLETED</span>
                                        </li>
                                    </ul>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md4 pr-0>
                <v-card class="dashbrd-border">
                    <v-card-text pa-0>
                        <v-flex xs12 pa-0>
                            <h1 class="titleH1">
                                <v-icon>fa-cube</v-icon>
                                <router-link :to="{ name: 'ImrUsers'}">
                                    MAXMARKETING
                                </router-link>
                            </h1>
                        </v-flex>
                        <v-layout wrap>
                            <v-flex xs12 pa-0 class="text-md-center">
                                <div class=" blockDiv">
                                    <ul>
                                        <li>
                                            <h1>{{maxMarketingSignupCompleted}}</h1>
                                            <span>ALL SIGNUPS</span>
                                        </li>
                                        <li>
                                            <h1>{{maxMarketingSignupMonth}}</h1>
                                            <!--<span class="coming">coming soon</span>-->
                                            <span>MONTHLY SIGNUPS</span>
                                        </li>
                                    </ul>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <template v-for="(imrDetail, imrIndex) in imrDetails">
                <v-flex xs12 md4 :key="imrIndex">
                    <v-card>
                        <v-card-text>
                            <v-flex xs12>
                                <h1 class="titleH1">
                                    <v-icon>fa-facebook-square</v-icon>
                                    {{imrIndex}}
                                </h1>
                            </v-flex>
                            <v-layout wrap>
                                <v-flex xs12 class="text-md-center socailsliders">
                                    <slider animation="normal" :autoplay="false" height="195px" :indicators="false">
                                        <slider-item v-for="(codeDetail, codeIndex) in imrDetail" :key="codeIndex" :style="codeDetail">
                                            <div class="socailclick">
                                                <!--<p class="codetxt">CODE</p>-->
                                                <p class="codeLabel">{{codeIndex}}</p>
                                                <div class="socialCover">
                                                    <div class="socailDiv">
                                                        <h1>{{codeDetail.hit.reduce((a, b) => a + b, 0)}}</h1>
                                                        <span>Clicked</span>
                                                    </div>
                                                    <div class="socailDiv">
                                                        <h1>{{codeDetail.completed.reduce((a, b) => a + b, 0)}}</h1>
                                                        <span>Completed</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </slider-item>
                                    </slider>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </template>
            <!-- <v-flex xs12>
          <v-card >
            <v-card-text>
              <v-flex xs12>
                <h1 class="titleH1">
                  <v-icon> fa-google</v-icon>
                  Google Analytics
                </h1>
              </v-flex>
              <v-layout>
                <v-flex lg4 md4 xs12>
                  <v-text-field label="User Name"  placeholder="" disabled=""></v-text-field>
                </v-flex>
                <v-flex lg4 md4 xs12>
                  <v-text-field label="Password"  placeholder="" disabled=""></v-text-field>
                </v-flex>
                <v-flex lg4 md4 xs12>
                  <v-btn block color="orange white--text" dark>SIGN IN</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex> -->
        </v-layout>
    </v-container>
    <GoogleAds></GoogleAds>
</div>
</template>

<script>
import API from "@/api";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import LoadSearchFormDb from "@/components/widgets/form/LoadSearchFormDb";
import TruckSearchFormDb from "@/components/widgets/form/TruckSearchFormDb";
import MyLoads from "@/pages/widgets/dashboard/MyLoads";
import MyTrucks from "@/pages/widgets/dashboard/MyTrucks";
import config from "../config";
import services from "../services/HttpService";
import GoogleAds from "@/pages/widgets/GoogleAds";
import moment from "moment";
import {
    Slider,
    SliderItem
} from "vue-easy-slider";
export default {
    components: {
        VWidget,
        LoadSearchFormDb,
        TruckSearchFormDb,
        MyLoads,
        MyTrucks,
        GoogleAds,
        Slider,
        SliderItem,
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        async getEquipmentTypes() {
            const self = this;
            await services.get("equipments/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }).then(res => {
                    self.equipment_types.push({
                        'name': config.ANYStr,
                        'code': config.ANYStr
                    });
                    res.data.data.map(function (data) {
                        let newArr = {};
                        newArr.name = data.name;
                        newArr.code = data.code;
                        self.equipment_types.push(newArr);
                    });
                    self.equipment_type_id_list.push(config.ANYStr);
                })
                .catch(err => {
                    self._showToast(err.message, config.errMsgColorStr);
                });
        },
        async checkSuperadmin() {
            const self = this;
            self.Issuperadmin = await self.$store.state.user.Issuperadmin;
        },
        async getAnalyticsData() {
            const self = this;
            await services.get("users/dash-analytics", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }).then(res => {
                    if (res.data.analytics) {
                        self.dashAnalyticsData = res.data.analytics;
                        self.dashAnalyticsData["userStatusData"] = [];
                        if (res.data.status) {
                            let statusArray = Object.keys(res.data.status);
                            statusArray.forEach(async function (status) {
                                let statusData = {
                                    "label": res.data.status[status],
                                    "value": (self.dashAnalyticsData.statusWiseUsersCount[status]) ? self.dashAnalyticsData.statusWiseUsersCount[status] : config.dashboardDefaultValue
                                }
                                await self.dashAnalyticsData["userStatusData"].push(statusData);
                            });
                        }
                    }
                })
                .catch(err => {
                    self._showToast(err.message, config.errMsgColorStr);
                });
        },
        async getLoadHistoricalData() {
            const self = this;
            await services.get("loads/historical", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }).then(res => {
                    if (res.data.loads_counter) {
                        self.loadHistoricalData = res.data.loads_counter;
                    } else {
                        self._showToast(res.data.message, config.errMsgColorStr);
                    }
                })
                .catch(err => {
                    self._showToast(err.message, config.errMsgColorStr);
                });
        },
        getImrDetails() {
            const self = this;
            services.get("code-details/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }).then(res => {

                    if (res.data.data.length > 0) {
                        let imrDetails = {};

                        res.data.data.map(function (val) {

                            if (typeof imrDetails[val.source_name] == 'undefined') {
                                imrDetails[val.source_name] = {};
                            }

                            if (typeof imrDetails[val.source_name][val.code] == 'undefined') {
                                imrDetails[val.source_name][val.code] = {};
                                imrDetails[val.source_name][val.code]['hit'] = [];
                                imrDetails[val.source_name][val.code]['hit'].push(val.hit_count);
                                imrDetails[val.source_name][val.code]['completed'] = [];
                                imrDetails[val.source_name][val.code]['completed'].push(val.sign_up_count);
                                // imrDetails[val.source_name][val.code] = [];
                                // imrDetails[val.source_name][val.code].push(val)
                            } else {
                                imrDetails[val.source_name][val.code]['hit'].push(val.hit_count);
                                imrDetails[val.source_name][val.code]['completed'].push(val.sign_up_count);
                                // imrDetails[val.source_name][val.code].push(val)
                                // imrDetails[val.source_name][val.code].push(val)
                            }
                        });
                        self.imrDetails = Object.assign({}, imrDetails);
                    }
                })
                .catch(err => {
                    self._showToast(err.message, config.errMsgColorStr);
                });
        },
        getMpCodeDetails() {
            const self = this;
            services.get("users/code-analytics", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }).then(res => {
                    if (!res.data.is_error) {
                        self.mpCodesAll = res.data.data.code_count;
                        self.mpCodesClick = res.data.data.hit_count;
                        self.mpCodesCompleted = res.data.data.sign_up_count;
                    }
                })
                .catch(err => {
                    self._showToast(err.message, config.errMsgColorStr);
                });
        },
        getAvgLoadsCount() {
            const self = this;
            services.get("loads/calculate-avg-loads", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }).then(res => {
                    if (!res.data.is_error) {
                        self.loadsAvg = res.data.loads_avg;
                        self.postonceloadsAvg = res.data.postonce_loads_avg;
                        // self.mpCodesClick = res.data.data.hit_count;
                        // self.mpCodesCompleted = res.data.data.sign_up_count;
                    }
                })
                .catch(err => {
                    self._showToast(err.message, config.errMsgColorStr);
                });
        },
        getMaxMarketingDetails() {
            const self = this;
            services.get("users/maxmarketing-analytics", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }).then(res => {
                    if (!res.data.is_error) {
                        self.maxMarketingSignupCompleted = res.data.data.signup_completed;
                        self.maxMarketingSignupMonth = res.data.data.signup_monthly;
                    }
                })
                .catch(err => {
                    self._showToast(err.message, config.errMsgColorStr);
                });
        }
    },
    data: () => ({
        // componentKey:1,
        color: Material,
        showLoadSearchTab: false,
        showTruckSearchTab: false,
        equipment_type_id_list: [],
        equipment_types: [],
        selectedTabType: "load",
        Issuperadmin: false,
        dashAnalyticsData: {},
        dashboardDefaultValue: config.dashboardDefaultValue,
        imrDetails: [],
        loadHistoricalData: 0,
        mpCodesAll: 0,
        mpCodesClick: 0,
        loadsAvg: 0,
        postonceloadsAvg: 0,
        mpCodesCompleted: 0,
        maxMarketingSignupCompleted: 0,
        maxMarketingSignupMonth: 0,
        userStore: null
    }),
    mounted() {
        const self = this;
        const storData = self.$store.state.user.permissions;
        for (var data in storData) {
            if ((data == 'load_searches') && (storData[data] == 'all' || storData[data] == 'view')) {
                self.showLoadSearchTab = true;
            }
            if ((data == 'truck_searches') && (storData[data] == 'all' || storData[data] == 'view')) {
                self.showTruckSearchTab = true;
            }
        };
    },
    async created() {
        const self = this;
        // self.componentKey = self.$store.state.loginTimeStamp;
        self.userStore = self.$store.state;
        await self.checkSuperadmin();
        if (!self.Issuperadmin) {
            self.getEquipmentTypes();
        } else {
            // self.getImrDetails();
            self.getAnalyticsData();
            self.getLoadHistoricalData();
            self.getMpCodeDetails();
            self.getMaxMarketingDetails();
            self.getAvgLoadsCount();
        }
    },
    computed: {
        posts() {
            return API.getPost(3);
        },
        siteTrafficData() {
            return API.getMonthVisit;
        },
        locationData() {
            return API.getLocation;
        },
        geTodayDate: function () {
            let todayDate = new Date().toDateString();
            return todayDate;
        }
    }
};
</script>

<style lang="stylus">
.v-datatable.v-table {
    .v-chip.v-chip--label {
        margin: 4px 4px 4px 16px
    }
}

.dashboard-tiles {
    margin: 10px 10px 0px 0px;
    width: 100%;
}

.dashboard-tiles-link:hover {
    opacity: 0.80;
}

.v-toolbar {
    box-shadow: none !important;
}

.dashboard-toolbar-admin {
    color: #ffffff;
}

.coming {
    color: #ff812b !important;
    font-size: 18px !important;
    font-weight: bold !important;
}

.socailsliders .slider {
    z-index: 0
}

.socailclick {
    text-align: center;
    height: 145px;
    border-radius: 30px;
    border: #5e5f61 solid 3px;
    margin: 16px 36px;
}

.socailclick p {
    margin: 0
}

.socialCover {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;

}

.socailDiv {
    box-sizing: border-box;
    flex-basis: 100%;
}

.socailDiv h1 {
    color: #ff812b;
    font-size: 36px;
    font-weight: 500;
}

.socailDiv span {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 500;
    color: #57585a;
}

.codetxt {
    color: #ff812b;
    font-size: 11px;
    font-weight: 500;
    padding: 0;
    margin: 5px 0 0 0;
}

.socailsliders .slider-btn,
.socailsliders .slider-btn-left {
    background: none !important;
}

.socailsliders .slider-icon,
.socailsliders .slider-btn:hover .slider-icon {
    border-left: 2px solid rgba(87, 88, 90, 1) !important;
    border-bottom: 2px solid rgba(87, 88, 90, 1) !important;
}

.slider-btn:hover .slider-icon {
    border-color: rgb(87, 88, 90)important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard.vue